module.exports = __webpack_public_path__ + "media/scripts/pages/csr/assets/media/logos/ZWSG-compact-f6670fa184288f87fe9765d4f091492b.png";